import {
  BracketCellForm,
  IMatch,
} from '../pages/tourDetails/TournamentPlay/components/PlayTag/PlayTag';
import { mapMatchToBracketCellPatchPayload } from './playTagTypeConverter';

function stableStringify(obj: Record<string, unknown>): string {
  const keys = Object.keys(obj).sort();
  const sorted: Record<string, unknown> = {};
  for (const k of keys) {
    sorted[k] = obj[k];
  }
  return JSON.stringify(sorted);
}

export function matchPatchFieldsEqual(
  current: IMatch,
  baseline: IMatch,
  timeZone?: string,
): boolean {
  const a = mapMatchToBracketCellPatchPayload(current, timeZone);
  const b = mapMatchToBracketCellPatchPayload(baseline, timeZone);
  return stableStringify(a) === stableStringify(b);
}

function normalizeBracketCellFormField(
  key: keyof BracketCellForm,
  value: unknown,
): unknown {
  if (value === '' || value === undefined) {
    return undefined;
  }
  if (key === 'isGold') {
    return String(value);
  }
  if (key === 'progressionExplanation') {
    return value == null ? null : JSON.stringify(value);
  }
  return value;
}

export function bracketCellFormFieldsEqual(
  current?: BracketCellForm,
  baseline?: BracketCellForm,
): boolean {
  if (!baseline) {
    return true;
  }
  if (!current && !baseline) {
    return true;
  }
  if (!current || !baseline) {
    return false;
  }
  const keys: (keyof BracketCellForm)[] = [
    'winnerTeamId',
    'loserTeamId',
    'progressionMode',
    'status',
    'round',
    'isGold',
    'bracket',
    'progressedAt',
    'progressionExplanation',
  ];
  for (const key of keys) {
    if (
      normalizeBracketCellFormField(key, current[key]) !==
      normalizeBracketCellFormField(key, baseline[key])
    ) {
      return false;
    }
  }
  return true;
}

export function bracketCellMetadataPatchChanged(
  current?: Record<string, unknown>,
  baseline?: Record<string, unknown>,
): boolean {
  const metadataKeys = (patch?: Record<string, unknown>) =>
    Object.keys(patch ?? {})
      .filter((k) => k !== 'matchCount')
      .sort();

  const currentKeys = metadataKeys(current);
  const baselineKeys = metadataKeys(baseline);
  if (currentKeys.length === 0 && baselineKeys.length === 0) {
    return false;
  }
  const pick = (patch: Record<string, unknown> | undefined, keys: string[]) => {
    const out: Record<string, unknown> = {};
    for (const k of keys) {
      out[k] = patch?.[k];
    }
    return out;
  };
  const allKeys = [...new Set([...currentKeys, ...baselineKeys])].sort();
  return (
    stableStringify(pick(current, allKeys)) !== stableStringify(pick(baseline, allKeys))
  );
}

export function anchorMatchHasChanges(
  anchor: IMatch | undefined,
  baselineAnchor: IMatch | undefined,
  bracketCellPatch: Record<string, unknown> | undefined,
  baselineBracketCellPatch: Record<string, unknown> | undefined,
  timeZone?: string,
): boolean {
  if (!anchor || typeof anchor.id !== 'number') {
    return false;
  }
  if (!baselineAnchor) {
    return false;
  }
  if (!matchPatchFieldsEqual(anchor, baselineAnchor, timeZone)) {
    return true;
  }
  return bracketCellMetadataPatchChanged(bracketCellPatch, baselineBracketCellPatch);
}
